import {
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  increment
} from 'firebase/firestore';

import {
  auth,
  db
} from '../utils/firebase';

const CONVERSATIONS =
  'jobconversations';

export async function getCandidateConversations() {

  try {

    const candidateId =
      auth.currentUser?.uid;

    if (!candidateId) {
      return [];
    }

    const q = query(
      collection(
        db,
        CONVERSATIONS
      ),
      where(
        'candidateId',
        '==',
        candidateId
      ),
      orderBy(
        'updatedAt',
        'desc'
      )
    );

    const snapshot =
      await getDocs(q);

    return snapshot.docs.map(
      doc => ({
        id:
          doc.id,

        ...doc.data()
      })
    );

  } catch (error) {

    console.error(
      'getCandidateConversations error:',
      error
    );

    return [];

  }

}

export function getConversationId(
  applicationId
) {
  return `application_${applicationId}`;
}

export async function createConversationForApplication(
  application
) {
  const conversationId =
    getConversationId(application.id);

  const ref =
    doc(
      db,
      CONVERSATIONS,
      conversationId
    );

  const candidateName =

    application.candidateName ||

    `${application.firstName || ''} ${application.lastName || ''}`.trim() ||

    'A candidate';
  
  const snap =
    await getDoc(ref);

  if (snap.exists()) {
    return conversationId;
  }

  await setDoc(ref, {
    applicationId: application.id,
    jobId: application.jobId,
    employerId: application.employerId,
    candidateId: application.candidateId,

    candidateName:
      `${application.firstName} ${application.lastName}`,

    employerName:
      application.company || '',

    jobTitle:
      application.jobTitle || '',

    company:
      application.company || '',

    lastMessage: '',
    lastMessageAt: null,

    employerUnread: 0,
    candidateUnread: 0,

    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });

  await addDoc(
    collection(
        db,
        CONVERSATIONS,
        conversationId,
        'messages'
    ),
    {
        senderId: 'system',

        senderType: 'system',

        body:
         `${candidateName}
            applied for
            ${application.jobTitle}`,

        createdAt:
        serverTimestamp(),

        readByEmployer: true,

        readByCandidate: true
    }
    );
  return conversationId;
}

export async function sendConversationMessage({
  application,
  body,
  senderType
}) {
  const userId =
    auth.currentUser?.uid;

  if (!userId) {
    throw new Error(
      'User must be logged in.'
    );
  }

  const conversationId =
    await createConversationForApplication(
      application
    );

  const messagesRef =
    collection(
      db,
      CONVERSATIONS,
      conversationId,
      'messages'
    );

  await addDoc(messagesRef, {
    senderId: userId,
    senderType,
    body,
    createdAt: serverTimestamp(),
    readByEmployer:
      senderType === 'employer',
    readByCandidate:
      senderType === 'candidate'
  });

  const updatePayload = {
    lastMessage: body,
    lastMessageAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  if (senderType === 'employer') {
    updatePayload.candidateUnread =
      increment(1);
  }

  if (senderType === 'candidate') {
    updatePayload.employerUnread =
      increment(1);
  }

  await updateDoc(
    doc(
      db,
      CONVERSATIONS,
      conversationId
    ),
    updatePayload
  );

  return {
    success: true,
    conversationId
  };
}

export async function getMessagesForApplication(
  applicationId
) {
  const conversationId =
    getConversationId(applicationId);

  const messagesQuery =
    query(
      collection(
        db,
        CONVERSATIONS,
        conversationId,
        'messages'
      ),
      orderBy('createdAt', 'asc')
    );

  const snap =
    await getDocs(messagesQuery);

  return snap.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
}

export async function markConversationRead(
  applicationId,
  viewerType
) {
  const conversationId =
    getConversationId(applicationId);

  const payload =
    viewerType === 'employer'
      ? { employerUnread: 0 }
      : { candidateUnread: 0 };

  await updateDoc(
    doc(
      db,
      CONVERSATIONS,
      conversationId
    ),
    {
      ...payload,
      updatedAt: serverTimestamp()
    }
  );
}